import RainbowRoninImage from '../../assets/rainbow-ronin.jpg'
import FluffyRoninImage from '../../assets/fluffy-ronin.jpg'
import FlatulentToadImage from '../../assets/flatulent-toad.jpg'
import TipperDataInMiddle from '../../assets/tipper-data-in-middle.png'
import TipperStalkerWare from '../../assets/tipper-stalkerware.png'
import TipperNickname from '../../assets/tipper-nickname.png'
import TrustBrokenImage from '../../assets/trust-broken.png'
import TipperAndroidMalwareAsAService from '../../assets/tipper-android-malware-as-a-service.png'
import TipperScatteredSpider from '../../assets/tipper-scattered-spider.png'
import TipperTheRiseOfMobileMFAs from '../../assets/tipper-the-rise-of-mobile-mfa.png'
import TipperPARSDefense from '../../assets/tipper-pars-defense.png'
import TipperHyperRat from '../../assets/tipper-hyper-rat.png'

const imageMapping: Record<
  | 'Rainbow Ronin'
  | 'Fluffy Ronin'
  | 'Flatulent Toad'
  | 'The History of Stalkerware'
  | 'Abusing Data in the Middle'
  | 'What’s in a (Nick)name'
  | 'Trust Broken at the Core'
  | 'How Android Malware-as-a-Service Is Redefining Mobile Threats'
  | 'Scattered Spider’s Mobile-Centric Modus Operandi'
  | 'The Rise of Mobile MFA Bypass Tools in Cybercrime'
  | 'PARS Defense - Tracing a New Player in the Spyware Industry'
  | 'HyperRat – A New Android RAT Sold On Cybercrime Networks',
  string
> = {
  'Rainbow Ronin': RainbowRoninImage,
  'Fluffy Ronin': FluffyRoninImage,
  'Flatulent Toad': FlatulentToadImage,
  'The History of Stalkerware': TipperStalkerWare,
  'Abusing Data in the Middle': TipperDataInMiddle,
  'What’s in a (Nick)name': TipperNickname,
  'Trust Broken at the Core': TrustBrokenImage,
  'How Android Malware-as-a-Service Is Redefining Mobile Threats': TipperAndroidMalwareAsAService,
  'Scattered Spider’s Mobile-Centric Modus Operandi': TipperScatteredSpider,
  'The Rise of Mobile MFA Bypass Tools in Cybercrime': TipperTheRiseOfMobileMFAs,
  'PARS Defense - Tracing a New Player in the Spyware Industry': TipperPARSDefense,
  'HyperRat – A New Android RAT Sold On Cybercrime Networks': TipperHyperRat,
}

export default imageMapping
